import { Link as MuiLink, Tooltip, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { com } from '@eidu/web'
import useEntityById from '../../io/useEntityById'
import entityIdFromStringOrNull = com.eidu.sharedlib.entity.entityIdFromStringOrNull

type Props = {
  entityId: string
  showTooltip?: boolean
  variant?: 'default' | 'emphasized'
  historicalLabel?: string | null
}

const EntityLink = ({ entityId, showTooltip = true, variant = 'default', historicalLabel }: Props) => {
  const id = entityIdFromStringOrNull(entityId) ?? undefined
  const { entity, loading } = useEntityById(id)

  if (!id)
    return (
      <Typography component="span" variant="inherit" fontFamily="monospace">
        {entityId}
      </Typography>
    )

  if (loading && !entity)
    return (
      <Typography component="span" variant="inherit" color="text.secondary">
        …
      </Typography>
    )

  const liveLabel = entity?.primaryLabelText || undefined
  const showHistoricalSuffix = !!liveLabel && !!historicalLabel && liveLabel !== historicalLabel
  const resolvedLabel = liveLabel || historicalLabel || undefined
  const label = showHistoricalSuffix ? `${liveLabel} (Old label: ${historicalLabel})` : resolvedLabel ?? entityId
  const fallbackToId = !resolvedLabel

  const text = (
    <Typography
      component="span"
      variant="inherit"
      fontFamily={fallbackToId ? 'monospace' : undefined}
      sx={variant === 'emphasized' ? { fontWeight: 500 } : undefined}
    >
      {label}
    </Typography>
  )

  const link = entity ? (
    <MuiLink
      component={RouterLink}
      to={`/entities/${entity.entity.typeId.toString()}/view/${entity.entity.id.toString()}`}
      underline="hover"
      color={variant === 'emphasized' ? 'text.primary' : 'inherit'}
    >
      {text}
    </MuiLink>
  ) : (
    text
  )

  return showTooltip ? (
    <Tooltip title={entityId} placement="top">
      <span>{link}</span>
    </Tooltip>
  ) : (
    link
  )
}

export default EntityLink
